import React from "react";
import { Route, Switch } from "react-router";

import * as Sentry from "@sentry/react";

import { OverSlaSummaryContainer } from "../containers/oversla/OverSlaSummaryContainer";
import { MonitoringPodKepalaKurirContainer } from "../containers/monitoringPod/MonitoringPodKepalaKurirContainer";
import { MonitoringPodKepalaKurirDetailCourierContainer } from "../containers/monitoringPod/MonitoringPodKepalaKurirDetailCourierContainer";
import { MonitoringPodNewDetail } from "../containers/monitoringPod/MonitoringPodNewDetail";
import { MonitoringPodContainer } from "../containers/monitoringPod/MonitoringPodContainer";
import { MonitoringPodDetailContainer } from "../containers/monitoringPod/MonitoringPodDetailContainer";

import { CheckAwbHistoryContainer } from "../containers/check-awb-history/CheckAwbHistoryContainer";

import { ResiXxxContainer } from "../containers/resi-xxx/ResiXxxContainer";
import { ResiXxxKibanaContainer } from "../containers/resi-xxx-kibana/ResiXxxKibanaContainer";

import { ReturnInProgressContainer } from "../containers/return-in-progress/ReturnInProgressContainer";
import { ReturnInProgressKibanaContainer } from "../containers/return-in-progress-kibana/ReturnInProgressKibanaContainer";

import { LayoutAdmin } from "../layouts/admin/LayoutAdmin";
import { AntNotDlvContainer } from "../containers/ant-not-dlv/AntNotDlvContainer";
import { OverSlaContainer } from "../containers/oversla/OverSlaContainer";
import { OverSlaKibanaContainer } from "../containers/oversla-kibana/OverSlaKibanaContainer";

import { AwbImageContainer } from "../containers/awb/AwbImageContainer";
import { KioskContainer } from "../containers/kiosk/KioskContainer";
import { AwbListContainer } from "../containers/awb-list/AwbListContainer";
import { UndeliveredContainer } from "../containers/undelivered/UndeliveredContainer";
import { UndeliveredKibanaContainer } from "../containers/undelivered-kibana/UndeliveredKibanaContainer";
import { MonitoringLinHaulContainer } from "../containers/monitoringLineHaul/MonitoringLinHaulContainer";
import { IdleawbContainer } from "../containers/idleawb/IdleawbContainer";
import { DeliveryPerformanceByDestinationCapacityContainer } from "../containers/deliveryPerformance/DeliveryPerformanceByDestinationContainer";
import { DeliveryCapacitySummaryContainer } from "../containers/capacity/DeliveryCapacitySummary";
import { AuditTrackingCodSummaryContainer } from "../containers/auditCod/AuditTrackingCodSummaryContainer";
import { AuditTrackingCodDetailCourierContainer } from "../containers/auditCod/AuditTrackingCodDetailCourierContainer";
import { ProduktivitasSummaryContainer } from "../containers/monitoringPodNew/produktivitas/ProduktivitasSummaryContainer";
import { OverSlaMetaBaseSummaryContainer } from "../containers/monitoringPodNew/overSlaMetaBase/OverSlaMetaBaseSummaryContainer";
import { ProductivitasMetaBaseSummaryContainer } from "../containers/monitoringPodNew/productivitasMetaBase/ProduktivitasSummaryContainer";
import { UpdateToleransiContainer } from "../containers/monitoringPodNew/updateToleransi/UpdateToleransiContainer";

import { TrackingSiteContainer } from "../containers/trackingSite/TrackingSiteContainer";
import { DeliveryCapacityPerwakilanContainer } from "../containers/capacity/DeliveryCapacityPerwakilan";
import { ReportMonitoringPopContainer } from "../containers/pickup/reports/ReportMonitoringPopContainer";
import { ReportOntimePerformancePickupContainer } from "../containers/pickup/reports/ReportOntimePerformancePickupContainer";
import { ReportKpiPerformancePickupContainer } from "../containers/pickup/reports/ReportKpiPerformancePickupContainer";
import { CourierDeliverySummaryContainer } from "../containers/monitoringPod/courierDeliverySummary/CourierDeliverySummaryContainer";
import { AwbListKibanaContainer } from "../containers/awb-list-kibana/AwbListKibanaContainer";
import { IdleAwbKibanaContainer } from "../containers/idleawb-kibana/IdleAwbKibanaContainer";
import { WeightDifferenceContainer } from "../containers/weight-difference/WeightDifferenceContainer";
import { MonitoringPodKepalaKurirContainerNew } from "../containers/monitoringPodNew/MonitoringPodKepalaKurirContainer";
import { MonitoringPodKepalaKurirDetailCourierContainerNew } from "../containers/monitoringPodNew/MonitoringPodKepalaKurirDetailCourierContainer";
import { MonitoringPodDetailContainerNew } from "../containers/monitoringPodNew/MonitoringPodDetailContainerNew";
import { MonitoringPodContainerNew } from "../containers/monitoringPodNew/MonitoringPodContainerNew";
import { MonitoringPodSdsContainer } from "../containers/monitoringPodSds/MonitoringPodSdsContainer";
import { MonitoringPodSdsDetailContainer } from "../containers/monitoringPodSds/MonitoringPodSdsDetailContainer";
import { MonitoringPodSdsKepalaKurirContainer } from "../containers/monitoringPodSds/MonitoringPodSdsKepalaKurirContainer";
import { MonitoringPodSdsKepalaKurirDetailCourierContainer } from "../containers/monitoringPodSds/MonitoringPodSdsKepalaKurirDetailCourierContainer";
import { MonitoringFeeContainer } from "../containers/monitoringFee/MonitoringFeeContainer";
import { MonitoringFeeDetailContainer } from "../containers/monitoringFee/MonitoringFeeDetailContainer";
import { AnalyticCapacityContainer } from "../containers/analytic-capacity/AnalyticCapacityContainer";
import { ManifestPerwakilanListContainer } from "../containers/manifest-perwakilan/ManifestPerwakilanListContainer";
import { ManifestDestinationDistrictListContainer } from "../containers/manifest-perwakilan-dest/ManifestDestinationDistrictListContainer";
import { TargetPembawaanContainer } from "../containers/monitoringPodNew/targetPembawaan/TargetPembawaanContainer";
import { MonitoringUrgentContainer } from "../containers/monitoringUrgent/MonitoringUrgentContainer";

export const MonitoringRouter = () => {
  const userData = localStorage.getItem("userData")
      ? JSON.parse(localStorage.userData)
      : null;
  if (userData !== null) {
    const sentryUser = {
      userNik: userData.username,
      userName: userData.first_name,
      roleId: userData.role_id,
      roleName: userData.role_name
    }
    Sentry.setUser(sentryUser);
  }

  return (
    <Switch>
      <Route
        exact
        path="/admin/monitoring/pod"
        render={(props) => (
          <LayoutAdmin>
            <MonitoringPodContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/pod/detail"
        render={(props) => (
          <LayoutAdmin>
            <MonitoringPodDetailContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring-pod-palkur"
        render={(props) => (
          <LayoutAdmin>
            <MonitoringPodKepalaKurirContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring-pod-palkur/courier/detail"
        render={(props) => (
          <LayoutAdmin>
            <MonitoringPodKepalaKurirDetailCourierContainer {...props} />
          </LayoutAdmin>
        )}
      />
      <Route
        exact
        path="/admin/monitoring-pod-new/detail"
        render={(props) => (
          <LayoutAdmin>
            <MonitoringPodNewDetail {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/pod-new"
        render={(props) => (
          <LayoutAdmin>
            <MonitoringPodContainerNew {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/pod-new/detail"
        render={(props) => (
          <LayoutAdmin>
            <MonitoringPodDetailContainerNew {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring-pod-new-palkur"
        render={(props) => (
          <LayoutAdmin>
            <MonitoringPodKepalaKurirContainerNew {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/check-history-resi"
        render={(props) => (
          <LayoutAdmin>
            <CheckAwbHistoryContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/auditor-tracking-cod"
        render={(props) => (
          <LayoutAdmin>
           <AuditTrackingCodSummaryContainer {...props} />
          </LayoutAdmin>
        )}
      />
        <Route
        exact
        path="/admin/monitoring-tracking-cod/detail"
        render={(props) => (
          <LayoutAdmin>
            <AuditTrackingCodDetailCourierContainer {...props} />
          </LayoutAdmin>
        )}
      />


      <Route
        exact
        path="/admin/monitoring-pod-palkur/produktivitas"
        render={(props) => (
          <LayoutAdmin>
            <ProduktivitasSummaryContainer {...props} />
          </LayoutAdmin>
        )}
      />
      <Route
        exact
        path="/admin/monitoring-pod-palkur/productivitas-metabase"
        render={(props) => (
          <LayoutAdmin>
            <ProductivitasMetaBaseSummaryContainer {...props} />
          </LayoutAdmin>
        )}
      />
      <Route
        exact
        path="/admin/monitoring-pod-palkur/over-sla"
        render={(props) => (
          <LayoutAdmin>
            <OverSlaMetaBaseSummaryContainer {...props} />
          </LayoutAdmin>
        )}
      />
      <Route
        exact
        path="/admin/monitoring-pod-palkur/update-toleransi"
        render={(props) => (
          <LayoutAdmin>
            <UpdateToleransiContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring-pod-palkur/target-pembawaan"
        render={(props) => (
          <LayoutAdmin>
            <TargetPembawaanContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring-pod-new-palkur/courier/detail"
        render={(props) => (
          <LayoutAdmin>
            <MonitoringPodKepalaKurirDetailCourierContainerNew {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/pod-sds"
        render={(props) => (
          <LayoutAdmin>
            <MonitoringPodSdsContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/pod-sds/detail"
        render={(props) => (
          <LayoutAdmin>
            <MonitoringPodSdsDetailContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring-pod-sds-palkur"
        render={(props) => (
          <LayoutAdmin>
            <MonitoringPodSdsKepalaKurirContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring-pod-sds-palkur/courier/detail"
        render={(props) => (
          <LayoutAdmin>
            <MonitoringPodSdsKepalaKurirDetailCourierContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/awb-list"
        render={(props) => (
          <LayoutAdmin>
            <AwbListContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/awb-list-kibana"
        render={(props) => (
          <LayoutAdmin>
            <AwbListKibanaContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/undelivered"
        render={(props) => (
          <LayoutAdmin>
            <UndeliveredContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/undelivered-kibana"
        render={(props) => (
          <LayoutAdmin>
            <UndeliveredKibanaContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/idleawb"
        render={(props) => (
          <LayoutAdmin>
            <IdleawbContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/idleawb-Kibana"
        render={(props) => (
          <LayoutAdmin>
            <IdleAwbKibanaContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/oversla"
        render={(props) => (
          <LayoutAdmin>
            <OverSlaContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/oversla-kibana"
        render={(props) => (
          <LayoutAdmin>
            <OverSlaKibanaContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/ant-not-dlv"
        render={(props) => (
          <LayoutAdmin>
            <AntNotDlvContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/manifest-perwakilan"
        render={(props) => (
          <LayoutAdmin>
            <ManifestPerwakilanListContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/manifest-perwakilan-dest-district"
        render={(props) => (
          <LayoutAdmin>
            <ManifestDestinationDistrictListContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/return-in-progress"
        render={(props) => (
          <LayoutAdmin>
            <ReturnInProgressContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/return-in-progress-kibana"
        render={(props) => (
          <LayoutAdmin>
            <ReturnInProgressKibanaContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/resi-xxx"
        render={(props) => (
          <LayoutAdmin>
            <ResiXxxContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/resi-xxx-kibana"
        render={(props) => (
          <LayoutAdmin>
            <ResiXxxKibanaContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/selisih-berat"
        render={(props) => (
          <LayoutAdmin>
            <WeightDifferenceContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/pod/delivery-performance-by-destination"
        render={(props) => (
          <LayoutAdmin>
            <DeliveryPerformanceByDestinationCapacityContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/pod/delivery-capacity-perwakilan"
        render={(props) => (
          <LayoutAdmin>
            <DeliveryCapacityPerwakilanContainer {...props} />
          </LayoutAdmin>
        )}
      />
      <Route
        exact
        path="/admin/pod/delivery-capacity"
        render={(props) => (
          <LayoutAdmin>
            <DeliveryCapacitySummaryContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/pod/courier-delivery-summary"
        render={(props) => (
          <LayoutAdmin>
            <CourierDeliverySummaryContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/kiosk"
        render={(props) => (
          <LayoutAdmin>
            <KioskContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/monitoring/analytic-capacity"
        render={(props) => (
          <LayoutAdmin>
            <AnalyticCapacityContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/masterdata/trackingsites"
        render={(props) => (
          <LayoutAdmin>
            <TrackingSiteContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/monitor/trackingNote/showImage/:awb"
        render={(props) => <AwbImageContainer {...props} />}
      />

      <Route
        exact
        path="/admin/report/monitoring-pop"
        render={(props) => (
          <LayoutAdmin>
            <ReportMonitoringPopContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/report/ontime-performance-pickup"
        render={(props) => (
          <LayoutAdmin>
            <ReportOntimePerformancePickupContainer {...props} />
          </LayoutAdmin>
        )}
      />

      <Route
        exact
        path="/admin/report/kpi-performance-pickup"
        render={(props) => (
          <LayoutAdmin>
            <ReportKpiPerformancePickupContainer {...props} />
          </LayoutAdmin>
        )}
      />
      <Route
        exact
        path="/admin/monitoring/pod-fee"
        render={(props) => (
          <LayoutAdmin>
            <MonitoringFeeContainer {...props} />
          </LayoutAdmin>
        )}
      />
      <Route
        exact
        path="/admin/monitoring/pod-fee/detail"
        render={(props) => (
          <LayoutAdmin>
            <MonitoringFeeDetailContainer {...props} />
          </LayoutAdmin>
        )}
      />
       <Route
        exact
        path="/admin/monitoring-line-haul"
        render={(props) => (
          <LayoutAdmin>
            <MonitoringLinHaulContainer {...props} />
          </LayoutAdmin>
        )}
      />
      <Route
        exact
        path="/admin/monitoring-urgent"
        render={(props) => (
          <LayoutAdmin>
            <MonitoringUrgentContainer {...props} />
          </LayoutAdmin>
        )}
      />
    </Switch>
  );
};
